/* ============================================================
   GalleryView — 카드 그리드 뷰
   - 카드: 행 페이지의 커버(pages.cover, CSS background 값)/아이콘,
     title, select 칩 + 주요 속성(담당자/날짜) 2-3개
   - 카드 클릭 → 행 페이지(/page/:id) 이동 (RelationCell 과 동일 패턴)
   ============================================================ */
import { Link } from 'react-router-dom';
import { optClass, avaColor, fmtShort } from './viewPipeline';
import { personNames } from './computeValue';

export default function GalleryView({ columns, rows, peopleById, createRow }) {
  // 카드에 노출할 주요 속성: select 칩(최대 2) + 담당자 + 날짜
  const selectCols = columns.filter((c) => c.type === 'select').slice(0, 2);
  const personCol = columns.find((c) => c.type === 'person');
  const dateCol = columns.find((c) => c.type === 'date');

  return (
    <div className="gal-grid">
      {rows.map((r) => {
        // person: user id 배열(신규)/평문(레거시) 모두 이름으로 해석
        const pNames = personCol ? personNames(r.properties?.[personCol.key], peopleById) : [];
        const date = dateCol ? r.properties?.[dateCol.key] : '';
        return (
          <Link className="gal-card" key={r.page_id} to={`/page/${r.page_id}`}>
            <div
              className={`gal-cover${r.cover ? '' : ' empty'}`}
              style={r.cover ? { background: r.cover } : undefined}
            >
              {!r.cover && <span className="gal-cover-icon">{r.icon || '📄'}</span>}
            </div>
            <div className="gal-body">
              <div className="gal-title">
                <span className="gal-emoji">{r.icon || '📄'}</span>
                <span className="gal-name">{r.title || '제목 없음'}</span>
              </div>
              <div className="gal-props">
                {selectCols.map((c) => {
                  const v = r.properties?.[c.key];
                  if (!v) return null;
                  return (
                    <span key={c.key} className={`tag ${optClass(c, v)}`}>{v}</span>
                  );
                })}
                {pNames.length > 0 && (
                  <span className="person">
                    <span className="mav" style={{ background: avaColor(pNames[0]) }}>{pNames[0][0]}</span>
                    {pNames.join(', ')}
                  </span>
                )}
                {date && <span className="gal-date">📅 {fmtShort(date)}</span>}
              </div>
            </div>
          </Link>
        );
      })}
      <button className="gal-new" onClick={() => createRow()}>＋ 새로 만들기</button>
    </div>
  );
}
